import React, { useEffect, useState, useRef } from "react";
import {
  ClientsList,
  FetchSecurityMaster,
  addAllocations,
  lastFundPriceDate,
} from "../../api/api";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

const Allocations = () => {
  const [rowData, setRowData] = useState<any>(null);
  const [fundList, setFundList] = useState<any>(null);
  const [selectFundId, setSelectFundId] = useState<any>(null);
  const [fundPriceDate, setFundPriceDate] = useState<any>(null);
  const [allocType, setAllocType] = useState<any>([]);
  const [selectAllocType, setSelectAllocType] = useState<any>(null);
  const [clientsList, setClientsList] = useState([]);
  const [selectedClients, setSelectedClients] = useState<any>('');
  const selectedClient: any = Cookies.get("client");
  const formRef = useRef<any>(null);

  useEffect(() => {
    ClientsList(Cookies.get("newJwt"))
      .then(response => response.json())
      .then(response => {
        setClientsList(response);
  
        // Filter the data based on selectedClient
        const clientIdToFilter = parseInt(selectedClient); // Specify the clientID you want to filter
        const filteredData = response?.filter((item: any) => item.clientID === clientIdToFilter);
        setSelectedClients(filteredData);
      });
  }, [selectedClient]);
  

console.log("ClientsList", clientsList, selectedClients[0]?.allocDateType)
  useEffect(() => {
    FetchSecurityMaster(
      "TransactionCodesToAllocate",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    ).then((response) => {
      setRowData(response);
    });

    FetchSecurityMaster(
      "Fund",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    ).then((response) => {
      setFundList(response);
    });
  }, []);

  useEffect(() => {
    if (selectFundId?.id) {
      lastFundPriceDate(
        "AllocLastFundPriceDate",
        parseInt(selectedClient),
        selectFundId?.id,
        Cookies.get("newJwt")
      ).then((response) => {
        setFundPriceDate(response);
      });
    }
  }, [lastFundPriceDate, selectFundId]);

  function currencyFormat(num: any) {
    if (num) {
      return parseFloat(num)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    } else {
      return "0.00";
    }
  }

  const handleFund = (e: any) => {
    setSelectFundId(e[0]);
  };
  const handleSubmit = (event: any) => {
    console.log(event);
    event.preventDefault();

    const selectDate = event.target.elements.date.value;
    const form = event.target;

    const formData: { transactionCode: any; newTarget: any }[] = [];

    // Iterate over the table rows to retrieve the data
    const rows = form.querySelectorAll("tbody tr");
    rows.forEach((row: any) => {
      const transactionCode = row.querySelector(".text-start.w-25").textContent;
      const newTargetInput = row.querySelector(".form-control.w-50");
      const newTarget = newTargetInput.value.replaceAll(",", "");

      if (newTarget.trim() !== "") {
        formData.push({ transactionCode, newTarget });
      }
    });

    const formattedData = formData
      .map(({ transactionCode, newTarget }) => {
        return `${transactionCode}:${newTarget}`;
      })
      .join(",");

    const payload = {
      sessionID: "test",
      date: selectDate,
      allocateString: formattedData,
    };

    addAllocations(
      payload,
      parseInt(selectedClient),
      selectFundId?.id,
      Cookies.get("newJwt")
    )
      .then((response) => response.text())
      .then((response) => {
        const responseObject = JSON.parse(response);
        // Check if the object has an "errors" property
        if (responseObject?.returnCode !== 0) {
          toast.error("Error: " + responseObject?.returnMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success(responseObject?.returnMessage, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setFundPriceDate(null);
          setSelectFundId(null);
          //setRowData(null)
        }
      });

    form.reset();
  };

  const lastFund =
    fundPriceDate?.length > 0
      ? fundPriceDate[0].lastFundPriceDate.substring(0, 10)
      : "";

  const typeHeadOptions: any[] = [];

  fundList &&
    fundList.map((e: any) => {
      return typeHeadOptions.push({
        label: `${e.fund} - ${e.fundName}`,
        description: e.fund,
        id: e.fundID,
      });
    });

  useEffect(() => {
    FetchSecurityMaster(
      "AllocType",
      parseInt(selectedClient),
      Cookies.get("newJwt")
    )
      .then((response) => response)
      .then((response) => {
        setAllocType(response);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function handlestatementType(e: any) {
    setSelectAllocType(e.target.value);
  }

  const handleNewTargetChange = (event: any, index: any) => {
    let { value } = event.target;

    // Limit to two decimal places
    const decimalIndex = value.indexOf(".");
    if (decimalIndex !== -1) {
      value = value.slice(0, decimalIndex + 3); // Keep up to two decimal places
    }

    // Perform any additional validation or logic here

    // Update the rowData state with the new value
    const updatedRowData = [...rowData];
    updatedRowData[index].newTarget = value;
    setRowData(updatedRowData);
  };

  console.log("Handlestatement", fundPriceDate && fundPriceDate[0]?.nextAllocDate.substring(0, 10))
  console.log("fundPriceDate", fundPriceDate)
  return (
    <div className="w-100">
      <div className="header">
        <h1 className="header-title">Allocations</h1>
      </div>
      <div className="row w-100 card py-4 px-0">
        <div className="tradeForm position-relative">
          <form className="w-100 my-2 px-4" onSubmit={handleSubmit}>
            <div className="row">
              <label className="mb-3 col-md-2">Alloc Type</label>
              <div className="mb-3 col-md-3">
                <select
                  className="form-select text-small filter-participants form-control"
                  onChange={handlestatementType}
                >
                  <option value="">Select</option>
                  {allocType?.map((e: any) => {
                    return (
                      <option value={e.allocType} key={e.allocTypeID}>
                        {e.allocType}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="row">
              <label className="mb-3 col-md-2">Fund</label>
              <div className="mb-3 col-md-3">
                <Typeahead
                  id="basic-example"
                  onChange={handleFund}
                  options={typeHeadOptions}
                  placeholder="Choose Fund..."
                  selected={selectFundId ? [selectFundId] : []}
                />
              </div>
            </div>
            <div className="row">
              <label className="mb-3 col-md-2">Last Fund Price Date</label>
              <div className="mb-3 col-md-3 px-4">
                {fundPriceDate !== null
                  ? Array.isArray(fundPriceDate) &&
                    fundPriceDate.map((item) => {
                      const formattedDate =
                        `${selectedClients[0]?.allocDateType}-local` ===
                        "datetime-local"
                          ? item.lastFundPriceDate
                          : new Date(
                              item.lastFundPriceDate
                            ).toLocaleDateString();
                      return formattedDate;
                    })
                  : "--"}
              </div>
            </div>
            <div className="row">
              <label className="mb-3 col-md-2">Alloc Date</label>
              <div className="mb-3 col-md-3">
                <input
                  type={`${selectedClients[0]?.allocDateType}-local`}
                  className="form-control"
                  placeholder=""
                  name="date"
                  defaultValue={
                    fundPriceDate?.length > 0
                      ? `${selectedClients[0]?.allocDateType}-local` ===
                        "datetime-local"
                        ? fundPriceDate[0].nextAllocDate
                        : fundPriceDate[0].nextAllocDate.substring(0, 10)
                      : ""
                  }
                  min={lastFund}
                ></input>
              </div>
            </div>

            <div className="row mt-4 mx-1">
              <div className="chartjs-size-monitor">
                {selectAllocType &&
                selectAllocType !== "Trial Data" &&
                selectFundId !== undefined &&
                selectFundId !== null ? (
                  <div
                    className="chartjs-size-monitor-shrink row"
                    style={{ height: "580px" }}
                  >
                    <table
                      id="UpdateTargets"
                      className="table table-striped my-0 table-fixed"
                      style={{ height: "550px", width: "58%" }}
                    >
                      <thead>
                        <tr style={{ height: "42px", verticalAlign: "middle" }}>
                          <th className="text-Start w-25 d-none">
                            Transaction Code
                          </th>

                          <th className="d-none d-xl-table-cell text-start w-50">
                            Transaction Code
                          </th>

                          <th className="d-none d-xl-table-cell text-start px-5">
                            Alloc Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody style={{ height: "inherit", width: "58%" }}>
                        {rowData &&
                          rowData?.map((e: any, index: any) => {
                            const inputAmount = parseFloat(e.newTarget);
                            const a = currencyFormat(inputAmount);
                            return (
                              <tr key={index}>
                                <td className="text-start w-25 d-none">
                                  {e.transactionCode}
                                </td>
                                <td className="d-none d-xl-table-cell text-start w-50 ">
                                  {e.transactionCodeDesc}
                                </td>

                                <td>
                                  {selectAllocType === "Semi Trial Data" ? (
                                    <input
                                      type="text"
                                      className="form-control w-50 mx-3"
                                      onChange={(event) =>
                                        handleNewTargetChange(event, index)
                                      }
                                      title="Please enter a valid decimal number"
                                      defaultValue={
                                        selectAllocType === "Semi Trial Data"
                                          ? currencyFormat(e.amountToAlloacate)
                                          : undefined
                                      }
                                    />
                                  ) : null}
                                  {selectAllocType !== "Semi Trial Data" ? (
                                    <input
                                      key={e.transactionCode}
                                      type="text"
                                      className="form-control w-50 mx-3"
                                      onChange={(event) =>
                                        handleNewTargetChange(event, index)
                                      }
                                      title="Please enter a valid decimal number"
                                      //defaultValue={e.newTarget}
                                      onBlur={(value) => {
                                        return (value.target.value =
                                          currencyFormat(value.target.value));
                                      }}
                                      defaultValue={
                                        selectAllocType === "Semi Trial Data"
                                          ? currencyFormat(e.amountToAlloacate)
                                          : undefined
                                      }
                                    />
                                  ) : null}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                ) : null}
                <div className="row pt-4" style={{ width: "62%" }}>
                  <div className="float-end text-start px-0">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                    <button type="button" className="btn btn-link">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export { Allocations };
